import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { FeatherArrowLeft } from '../ui/icons';
import './PageHeader.css';

const PageHeader = ({ title, showBackButton = true, backUrl = '/dashboard', actions }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        {showBackButton && (
          <Button 
            variant="neutral-tertiary" 
            icon={<FeatherArrowLeft />}
            onClick={() => navigate(backUrl)}
          >
            Back
          </Button>
        )}
        <span className="text-2xl font-semibold text-default-font">{title}</span>
      </div>
      {/* <div className="flex items-center gap-4">
        {actions}
        <div className="flex flex-col items-end gap-1">
          <div className="user-avatar">
            <span className="user-initials">
              {user?.displayName?.split(' ').map(n => n[0]).join('') || 'U'}
            </span>
          </div>
          <span className="text-sm text-default-font">{user?.displayName?.split(' ')[0]}</span>
        </div>
      </div> */}
    </div>
  );
};

export default PageHeader; 